import React from 'react';
import {
  HashRouter, Routes, Route,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterSearchList, SearchListProps } from './router-search-list';
import { BrowserDetectionService } from '../../../services';

const queryClient = new QueryClient();

export const SearchList = (props : SearchListProps): JSX.Element => (
  <>
    { BrowserDetectionService.isBrowserContext() && (
      <QueryClientProvider client={queryClient}>
        <HashRouter basename="/">
          <Routes>
            <Route path={`/${props.tabName}?/:tab?/${props.queryName}?/:query?/${props.pageName}?/:page?`} element={<RouterSearchList {...props} />} />
          </Routes>
        </HashRouter>
      </QueryClientProvider>
    )}
  </>
);
